module.exports = __webpack_public_path__ + "img/caiwu.d3a6e0ae.svg";